import './App.css';
import axios from "axios";
import React, { useState } from 'react';

function App() {

  const looseId = '32322d66-2506-4715-af61-6e98c44173ca';

  const [playState, setPlayState] = useState(null);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    tel: '',
    email: '',
  });

  const [gain, setGain] = useState({});

  const submit = async (e) => {
    e.preventDefault();
    const res = await requestApi('', 'post', {
      input: {
        player_data: formData,
        lang: 'fr',
        game_id: '6aceaec2-78ea-4457-b1fe-fb2100fec545',
      },
    });

    if (res.data.success) {
      setTimeout(() => {
        setGain(res.data.data);
      }, 11000);
    }

    if (res.data.data.id === looseId) {
      setPlayState(false);
    } else {
      setPlayState(true);
    }
  }

  return (
    <div className="App">
      <img alt="" style={{ zIndex: 100, left: 0, top: 0, bjectFit: 'contain', width: '100%', position: 'absolute' }} src="./assets/box.png" />
      <div id="lam1" className={(playState === null) ? "lamelle" : (playState === true) ? 'lamelle win' : 'loose lamelle'} style={{ top: '460px', left: '190px', position: 'absolute', zIndex: 0, width: '120px', height: '320px' }}>

      </div>
      <div id="lam2" className={(playState === null) ? "lamelle" : (playState === true) ? 'lamelle win' : 'loose lamelle'} style={{ top: '460px', left: '374px', position: 'absolute', zIndex: 0, width: '120px', height: '320px' }}>

      </div>
      <div id="lam3" className={(playState === null) ? "lamelle" : (playState === true) ? 'lamelle win' : 'loose lamelle'} style={{ top: '460px', left: '560px', position: 'absolute', zIndex: 0, width: '120px', height: '320px' }}>

      </div>

      {
        playState === null &&
        <div style={{ display: 'flex', alignContent: 'center', position: 'absolute', top: '25vh', left: '15vw', zIndex: 100, width: '70vw', height: '50vh', backgroundColor: 'rgba(255, 255, 255, 0.84)', border: 'solid 2px #59b886', padding: '20px' }}>
          <form onSubmit={submit}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <h1 style={{ color: 'black', fontWeight: 'normal', fontSize: '24px' }}>Communiquez-nous votre adresse email
                pour être tenu informé.e des actualités
                du Salon Batimoi.
                du Salon Batimoi.
              </h1>
              <input onChange={(e) => { setFormData({ ...formData, first_name: e.target.value }) }} required value={formData.first_name} placeholder="Prénom" style={{ marginTop: '40px', padding: 8, borderRadius: '28px', fontSize: '24px', width: '80%' }} />
              <input onChange={(e) => { setFormData({ ...formData, last_name: e.target.value }) }} required value={formData.last_name} placeholder="Nom" style={{ marginTop: '40px', padding: 8, borderRadius: '28px', fontSize: '24px', width: '80%' }} />
              <input onChange={(e) => { setFormData({ ...formData, tel: e.target.value }) }} required value={formData.tel} type="tel" placeholder="Numéro de téléphone" style={{ marginTop: '40px', padding: 8, borderRadius: '28px', fontSize: '24px', width: '80%' }} />
              <input onChange={(e) => { setFormData({ ...formData, email: e.target.value }) }} required value={formData.email} type="email" placeholder="Adresse email" style={{ marginTop: '40px', padding: 8, borderRadius: '28px', fontSize: '24px', width: '80%' }} />
              <button type="submit" style={{ marginTop: '40px', padding: 8, borderRadius: '28px', fontSize: '24px', width: '80%', backgroundColor: '#E6723F', color: 'white', border: 'none', outline: 'none' }}>Envoyer</button>
            </div>
          </form>
        </div>
      }
      {
        gain && <img alt="" style={{margin: 'auto', width: '60%', left: '20%', top: '20%', position: 'absolute', zIndex: 500}} src={gain.uri}/>
      }
    </div>
  );
}

function requestApi(path, method, data) {
  const url = 'https://api-gain.web-treeosk.online/play';

  if (method === 'post') {
    return axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } else if (method === 'get') {
    return axios.get(url, { params: data });
  } else {
    console.log('error promise');
    return Promise.reject(new Error('Méthode de requête invalide'));
  }
}

export default App;
